import * as d3 from 'd3';
import _ from 'lodash';

export const getOppositeColor = _.memoize((color: string): string => {
  const { r, g, b } = d3.rgb(color);
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? `rgb(0,0,0)` : `rgb(255,255,255)`;
});
